/**
 * 品牌配置 —— 运行时按访问域名自动切换
 *
 * 说明：本站（bestdock.cn）目前只挂一个域名，所以只有一套品牌。
 * 保留和 site-B（fssy/acrdock）完全相同的结构，是为了：
 *   1. 两个站的 src 文件清单保持一致；
 *   2. 以后如果 bestdock.cn 也要挂第二个域名，直接往 HOST_MAP / BRANDS 里加一条即可。
 *
 * 用法：
 *   import BRAND from '../brand'
 *   import { applyBrandToHead } from './brand'
 */

// 域名 → 品牌 key。写主域名即可，会自动匹配 www. 及任意子域名
var HOST_MAP = {
    bestdock: ['bestdock.cn']
};

// 匹配不到任何域名时的兜底品牌（本地 localhost 开发也走这里）
var DEFAULT_BRAND = 'bestdock';

var BRANDS = {
    bestdock: {
        key: 'bestdock',
        // 头部 logo 用的是图片（assets/img/logo2.png），这里只作备用文字
        logoText: 'BEST DOCK',
        title: '经祥港工-水上浮桥，塑料浮筒，海洋渔排，专业游艇码头，浮动码头，钢结构码头，铝合金码头，景观浮桥',
        keywords: '水上浮桥,游艇码头,浮动码头,游船码头,亲水平台,码头建造，浮筒平台',
        description: '游艇码头专注于大型水上浮桥、水上码头、亲水平台、浮动码头、游艇码头、游船码头、景观浮桥、水上房屋等水上项目的策划、设计、建造、产品供应等一体化服务',
        brandCn: '开平经祥港口设施工程有限公司',
        // 正文里「XX是一家专业从事于…」前面的短名，用于标题/小标题
        brandShort: '经祥港工',
        companyCn: '开平经祥港口设施工程有限公司',
        companyEn: 'Kaiping Jingxiang Port Facilities Engineering Co., Ltd.',
        copyright: '©2022 开平经祥港口设施工程有限公司 BestDock COPYRIGHT. 版权所有',
        icp: '粤ICP备2022028720号',
        web: 'www.bestdock.cn',
        email: 'yannickhe@bestdock.cn',
        emails: 'yannickhe@bestdock.cn',
        tel: '199-2592-8565'
    }
};

function getHostname() {
    try {
        return (window.location.hostname || '').toLowerCase();
    } catch (e) {
        return '';
    }
}

function resolveBrandKey() {
    var host = getHostname();
    if (!host) return DEFAULT_BRAND;

    var keys = Object.keys(HOST_MAP);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var domains = HOST_MAP[key] || [];
        for (var j = 0; j < domains.length; j++) {
            var d = String(domains[j]).toLowerCase();
            // 命中主域名本身，或它的任意子域名（www.xxx / m.xxx ...）
            if (host === d || host.indexOf('.' + d) === host.length - d.length - 1) {
                return key;
            }
        }
    }
    return DEFAULT_BRAND;
}

function resolveBrand() {
    return BRANDS[resolveBrandKey()] || BRANDS[DEFAULT_BRAND];
}

var BRAND = resolveBrand();

/**
 * 把品牌文案写进 <head>（title / keywords / description）。
 */
function applyBrandToHead(brand) {
    var b = brand || BRAND;
    if (typeof document === 'undefined') return;

    if (b.title) document.title = b.title;

    var kw = document.querySelector('meta[name="keywords"]');
    if (kw) {
        kw.setAttribute('content', b.keywords);
    } else if (b.keywords) {
        var mk = document.createElement('meta');
        mk.setAttribute('name', 'keywords');
        mk.setAttribute('content', b.keywords);
        document.head.appendChild(mk);
    }

    var ds = document.querySelector('meta[name="description"]');
    if (ds) {
        ds.setAttribute('content', b.description);
    } else if (b.description) {
        var md = document.createElement('meta');
        md.setAttribute('name', 'description');
        md.setAttribute('content', b.description);
        document.head.appendChild(md);
    }
}

export default BRAND;
export { BRAND, BRANDS, HOST_MAP, DEFAULT_BRAND, resolveBrand, resolveBrandKey, applyBrandToHead };
